import { createListenerMiddleware } from '@reduxjs/toolkit';
import { clearPendingDeletes } from './rowPendingDeletionSlice';
import { commandApi } from 'app/apis/commandApi';
import { timeInMilliSecondsToWaitForDataToBeDeleted } from 'common/constants/timeout-values';
import { queryApi } from 'app/apis/queryApi';

export const revenueRowPendingDeletionListenerMiddleware =
  createListenerMiddleware();
export const opportunityRowPendingDeletionListenerMiddleware =
  createListenerMiddleware();

revenueRowPendingDeletionListenerMiddleware.startListening({
  matcher: commandApi.endpoints.deleteMultipleRevenues.matchFulfilled,
  effect: async (
    {
      meta: {
        arg: {
          originalArgs: { componentId }
        }
      }
    },
    listenerApi
  ) => {
    listenerApi.cancelActiveListeners();

    console.log('Waiting for revenue data to be deleted...');

    await listenerApi.delay(timeInMilliSecondsToWaitForDataToBeDeleted);

    listenerApi.dispatch(clearPendingDeletes({ componentId }));
    listenerApi.dispatch(queryApi.util.invalidateTags(['Revenue']));
  }
});

opportunityRowPendingDeletionListenerMiddleware.startListening({
  matcher: commandApi.endpoints.deleteMultipleOpportunities.matchFulfilled,
  effect: async (
    {
      meta: {
        arg: {
          originalArgs: { componentId }
        }
      }
    },
    listenerApi
  ) => {
    listenerApi.cancelActiveListeners();

    console.log('Waiting for opportunity data to be deleted...');

    await listenerApi.delay(timeInMilliSecondsToWaitForDataToBeDeleted);

    listenerApi.dispatch(clearPendingDeletes({ componentId }));
    listenerApi.dispatch(queryApi.util.invalidateTags(['Opportunities']));
  }
});
